import React, { useEffect } from "react";
import {
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import CommonButton from "../../../components/common/Button";
import Input from "../../../components/common/Input";
import { CloseIcon } from "../../../helper/Icons";
import { addUomInitialValues } from "../../../helper/initialValues";
import { uomValidationSchema } from "../../../helper/validation";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { notificationSuccess } from "../../../state/Action/NotificationAction";
import { updateUom,AddUom, UomDetail } from "../../../Service/uom.service";

const AddUom_modal = ({ modalOpen, handleClose, handelClick }) => {
  const id = modalOpen.id;

  const [loading, setLoading] = React.useState(false);

  const dispatch = useDispatch();

    const formik = useFormik({
    initialValues: addUomInitialValues,
    onSubmit: async (value) => {
      setLoading(true);
      const payload = {
        name: value.name,
      };

      const res = id ? await updateUom(id, payload) : await AddUom(payload);
      if (res.status) {
        setLoading(false);
        dispatch(notificationSuccess({
          show: true,
          type: 'success',
          message: res.message || 'Uom Added Successfully.'
        }
        ))
        handleClose();
      } else {
        setLoading(false);
        dispatch(notificationSuccess({
          show: true,
          type: 'error',
          message: res.message || 'Something went wrong.'
        }
        ))
      }
    },
    validationSchema: uomValidationSchema,
    });
  
  const getUomDetail = async () => {
    const res = await UomDetail(id);
    if (res.status) {
      formik.setFieldValue("name", res.data.name);
    }
  }

  useEffect(() => {
    if (id) {
      getUomDetail();
    }
  }, [])
  

  console.log("formik", formik);
  return (
    <>
      <DialogTitle sx={{ m: 0, p: 2 }} id="Common_modal">
        <Typography variant="h6">
          {id ? "Edit Uom" : "Add Uom"}
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ maxWidth: "500px", width: "100%" }}>
        <Grid container spacing={2} minWidth={{ xs: "100%", sm: "400px" }}>
          <Grid item xs={12} sm={12}>
            <Input labelinput={"Uom "} type="text"
              maxLength={50}
              {...formik.getFieldProps("name")}
              error={formik.touched.name && formik.errors.name}
              helperText={formik.touched.name && formik.errors.name}
              
            />
          </Grid>
          {/* <Grid item xs={12} sm={12}>
            <FormControl
              fullWidth
              variant="standard"
              sx={{ marginTop: "-6px" }}
            >
              <Autocomplete
                options={groups}
                multiple
                renderInput={(params) => (
                  <Input {...params} labelinput={"Surface"} />
                )}
              />
            </FormControl>
          </Grid> */}
        </Grid>
      </DialogContent>
      <DialogActions>
        <CommonButton
          buttonName="cancel"
          size="small"
          color="white"
          onClick={handleClose}
        />
        <CommonButton
          buttonName="Save"
          size="small"
          color="primary"
          onClick={
            formik.handleSubmit
          } 
        />
      </DialogActions>
    </>
  );
};

export default AddUom_modal;
